import React from "react";
import TimeAgo from "react-timeago";

const SiteTypeList = ({ items, onEdit }) => {
	if (items && items.length < 1)
		return (
			<div className="text-center">
				<h5>No Site type has been added yet</h5>
			</div>
		);
	return (
		<div className="inbox-body no-pad table-responsive">
			<table className="table table-inbox table-hover">
				<thead>
					<tr>
						<th className="text-center">SN</th>
						<th>Name</th>
						<th>Date Created</th>
						<th className="text-center">Edit</th>
					</tr>
				</thead>
				<tbody>
					{items &&
						items.map((type, index) => (
							<tr key={index}>
								<td className="inbox-small-cells text-center">
									{index + 1}
								</td>
								<td className="view-message">
									<h5>{type.name}</h5>
								</td>
								<td className="view-message">
									<TimeAgo
										date={new Date(
											parseInt(type.created_at)
										).toLocaleDateString()}
									></TimeAgo>
								</td>
								<td className="view-message text-center">
									<button
										onClick={() => onEdit(type)}
										className="mdl-button mdl-button--icon mdl-button--colored btn-default"
									>
										<i className="material-icons text-success">
											edit
										</i>
									</button>
								</td>
							</tr>
						))}
				</tbody>
			</table>
		</div>
	);
};

export default SiteTypeList;
